import { useEffect, useState } from 'react';
import { fetchPlayableServers, type PlayableServer } from '../api/servers';
import { ca } from '../i18n/ca';
import { usable } from './serverFit';

/**
 * A select of the group's servers, for the screens that ask which mod set they
 * are about: the campaign wizard and the catalogue. The server is the mod set —
 * on the owner's panel the mods are edited on each server, and a preset is a
 * Launcher file nobody looks at again (2026-09-19) — so where the platform used
 * to ask for a preset, it asks for a server.
 *
 * Only the servers the platform may use can be picked; the group's other ones
 * are listed greyed, with the way to link them, rather than hidden.
 */
export function ServerPicker({
  value,
  onChange,
}: {
  value: number | null;
  onChange: (server: PlayableServer | null) => void;
}) {
  const [servers, setServers] = useState<PlayableServer[]>([]);

  useEffect(() => {
    let live = true;
    fetchPlayableServers()
      .then((r) => live && setServers(r.servers))
      .catch(() => live && setServers([]));
    return () => {
      live = false;
    };
  }, []);

  const t = ca.missionUi.server;
  return (
    <label>
      {t.pick}
      <select
        name="server"
        value={value ?? ''}
        onChange={(e) => onChange(servers.find((s) => s.id === Number(e.target.value)) ?? null)}
      >
        <option value="">—</option>
        {servers.filter(usable).map((s) => (
          <option key={s.id} value={s.id}>
            {s.name} · {ca.missionUi.details.presetMods(s.activeMods?.length ?? 0)}
            {s.scanned === false ? ` · ${t.notScannedShort}` : ''}
          </option>
        ))}
        {servers
          .filter((s) => !usable(s))
          .map((s) => (
            <option key={s.id} value={s.id} disabled>
              {s.name} · {ca.missionUi.page.serverNotLinked}
            </option>
          ))}
      </select>
    </label>
  );
}
